/* ============================================================
   Why Choose TatvaSoft — benefit card carousel (Swiper 11)
   ------------------------------------------------------------
   Same Swiper import style as the other home carousels; auto-width
   cards with header nav ([data-why-prev]/[data-why-next]).
   ============================================================ */
import Swiper from "swiper";
import { Navigation } from "swiper/modules";

export function initWhyCarousel() {
  var el = document.querySelector(".why-choose-swiper");
  if (!el) return;

  var nav = document.querySelector(".why-choose-nav");

  var swiper = new Swiper(el, {
    modules: [Navigation],
    slidesPerView: "auto",
    loop: true,
    speed: 500
  });

  /* With only 4 cards they exactly fill the container on wide screens, so
     there is nothing to scroll and Swiper locks itself. Hide the arrows in
     that case rather than leaving dead controls; they come back as soon as
     the cards overflow (narrower viewports, or once more cards are added). */
  function syncNav() {
    if (nav) nav.hidden = !!swiper.isLocked;
  }
  syncNav();
  swiper.on("lock unlock resize", syncNav);

  document.querySelectorAll("[data-why-prev]").forEach(function (btn) {
    btn.addEventListener("click", function () {
      swiper.slidePrev();
    });
  });
  document.querySelectorAll("[data-why-next]").forEach(function (btn) {
    btn.addEventListener("click", function () {
      swiper.slideNext();
    });
  });
}
